import { lt } from '@mews/framework';
import { IconName } from '@optimus-web/icons';
import { TooltippedIconButton } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';

// TODO: implement action with new logic, will be in MMP-11729
export const PrinterAction = () => (
    <TooltippedIconButton
        icon={IconName.Print}
        tooltip={lt(TextKey.Print)}
        onClick={() => {
            // Handle print action
        }}
        type="button"
    />
);
